<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    created() {
      // this.$store.dispatch('connect')
      // 在页面加载时读取sessionStorage里的状态信息
      // if (sessionStorage.getItem('store')) {
      //   this.$store.replaceState(
      //     Object.assign({},
      //       this.$store.state,
      //       JSON.parse(sessionStorage.getItem('store'))
      //     )
      //   )
      // }

      if (window.localStorage.getItem('yunxin_json') != null) {
        this.$store.dispatch(
          "getyunxin",
          JSON.parse(window.localStorage.getItem('yunxin_json'))
        )
      }

      if(this.isMobile()) {
        // alert("移动端");
        // this.$router.replace('/pc_index');
        // window.location.href = "https://cloudvipm.sdzkedu.com"
      }

      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      // beforeunload事件在页面刷新时先触发
      // window.addEventListener('beforeunload', () => {
      //   // console.log(this.$store.state)
      //   // sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      // })
    },
    mounted() {
      if (this.isMobile()) {
        window.location.href = "https://cloudvipm.sdzkedu.com"
        // window.location.href = "http://cloudvipm.sdzkedu.com"
		// window.location.href = "http://cloudvipm.sdzkedu.com"
      }
      this.$nextTick(() =>{
        document.oncontextmenu = function(){
          return false
        }
      })
      document.onkeydown = function(e){
        if(e && e.keyCode === 123){
          console.log(e)
          e.returnValue = false
          e.keyCode = 0
          return false
        }
      }
    },
    updated() {
      // this.$store.dispatch('connect')
    },
    methods: {
      // 添加判断方法
      isMobile() {
        let flag = navigator.userAgent.match(/(phone|iPhone|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        if(navigator.userAgent.match(/(iPad|ipad|pad)/i)){
          return false;
        }
        return flag;
       }
    }
  }
</script>

<style>
  *{
   -webkit-touch-callout:none; /*系统默认菜单被禁用*/
   -webkit-user-select:auto; /*webkit浏览器*/
   -khtml-user-select:none; /*早期浏览器*/
   -moz-user-select:none;/*火狐*/
   -ms-user-select:none; /*IE10*/
   user-select:none;
  }
  body {
    padding: 0;
    margin: 0 auto;
    font-size: 16px;
    background: #f8f8f8;
    color: #333;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li,
  ol,
  ul {
    list-style: none;
  }

  h3,
  h4 {
    margin: 0;
  }

  a {
    text-decoration: none;
    outline: none;
  }

  p {
    margin: 0;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue